import React from 'react';
import Modal, { ModalBody, ModalHeader, ModalTitle, ModalFooter } from '../../../../components/bootstrap/Modal';
import Button from '../../../../components/bootstrap/Button';
import Card, { CardBody } from '../../../../components/bootstrap/Card';

const TicketsModal = ({ isOpen, setIsOpen, data }) => {
    if (!data || !data.report) return null;

    const itemsConfig = [
        { key: 'system', label: 'Sistema' },
        { key: 'pos', label: 'POS' },
        { key: 'posDelivery', label: 'POS Delivery' },
        { key: 'printer', label: 'Impressora' },
        { key: 'totem', label: 'Totem' },
        { key: 'tablet', label: 'Tablet' },
    ];

    return (
        <Modal
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            titleId="tickets-modal"
            isCentered
            size="lg"
        >
            <ModalHeader className="p-4 pb-2" setIsOpen={setIsOpen}>
                <ModalTitle id="tickets-modal-title">Detalhes do Chamado</ModalTitle>
            </ModalHeader>
            <ModalBody>
                <div className="p-4 pt-2">
                    <h5 className="mb-3">Justificativa</h5>
                    <p className='ps-2'>
                        {data.report.justification}
                    </p>

                    <h5 className="mb-3 mt-4">Itens do Chamado</h5>
                    <div className="row g-2">
                        {itemsConfig.map((item) => (
                            <div key={item.key} className="col-4 col-md-2">
                                <Card className="text-center mb-0">
                                    <CardBody className="p-2">
                                        <div className="text-muted small">{item.label}</div>
                                        <div className="fw-bold">
                                            {data.report?.items?.[item.key] || 0}
                                        </div>
                                    </CardBody>
                                </Card>
                            </div>
                        ))}
                    </div>

                    <div className="mt-4">
                        <small className="text-muted">
                            Data de abertura: {data.report.updated_at?.toDate().toLocaleString('pt-BR')}
                        </small>
                    </div>
                </div>
            </ModalBody>
            <ModalFooter className="p-4">
                <Button icon="Close" color="dark" onClick={() => setIsOpen(false)}>
                    Fechar
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default TicketsModal;